import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import VisibilityIcon from "@material-ui/icons/Visibility";
import PaymentIcon from "@material-ui/icons/Payment";
import styled from "@emotion/styled";
import UserInfo from "./UserInfo";
import { useSelector, useDispatch } from "react-redux";
import PeopleIcon from "@material-ui/icons/People";
import Teams from "./Teams";
import BillingCards from "./BillingCards";
import PlansAccount from "./PlansAccount";
import { getTeamMembers, setUser } from "../../redux/actions/user";
import { fetchCards, getPlans } from "../../services/sync";
import { getMe } from "../../services/auth";
import { toast } from "../../helpers/apiRequests";
import RenderByPermission from "components/RenderByPermission";

const isTeamMember = localStorage.getItem("team_member_uuid");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  backButton: {
    backgroundColor: "#f7c948",
    boxShadow: "0px 3px 6px #00000029",
    padding: "1vh 1.5vw",
    outline: "none",
    textDecoration: "none",
    border: "none",
    borderRadius: "6px",
    color: "white",
    marginBottom: "2%",
    margin: "1%",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  // const classes = useStyles();

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
          <br />
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
  // index: 2
};

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

const Accounts = () => {
  const [billings, setBillings] = useState(false);
  const classes = useStyles()
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const section = urlParams.get("section");

  const activeTab = () => {
    if (section === "plans") {
      return 2;
    } else {
      return 0;
    }
  };

  // const classes = useStyles();
  const [value, setValue] = useState(activeTab);
  const user = useSelector((state) => state.user.authUser);
  const [plans, setPlans] = useState([]);
  const [reloadStore, setReloadStore] = useState(false);
  const active_plan = user?.active_plan;
  const columns = [
    { title: "Card Type", field: "card_brand" },
    { title: "Card No", field: "last_four_digit" },
    { title: "Card Expiry", field: "card_expire" },
  ];
  const [cardList, setCardList] = useState({ data: [], columns: columns });
  const dispatch = useDispatch();

  const loadCards = useCallback(async () => {
    function cards() {
      fetchCards()
        .then((theCards) => {
          const cards = theCards.data;
          // if (cards.length < 1) {
          //   toast.notify("You're yet to have a card on for Sync, kindly click on the modal above to add one", { type: "info"} );
          // }

          setCardList({
            data: [],
            columns: [
              { title: "Card Type", field: "card_brand" },
              { title: "Card No", field: "last_four_digit" },
              { title: "Card Expiry", field: "card_expire" },
            ],
          });

          cards.forEach((d) => {
            setCardList((prevState) => {
              const data = [...prevState.data];
              data.push({
                card_brand: d.card_brand,
                last_four_digit: "***" + d.last_four_digit,
                card_expire: d.card_expire,
                hidden_action: d.make_default,
                hidden_id: d.id,
                created_at: d.created_at,
                make_default: d.make_default,
              });
              return { ...prevState, data };
            });
          });
        })
        .catch((e) => {
          toast.notify("Error fetching cards, try refreshing this page", {
            type: "error",
          });
        });
    }
    await cards();
  }, []);

  useEffect(() => {
    const reloadUser = async () => {
      const response = await getMe();

      dispatch(setUser(response.data));
    };
    dispatch(getTeamMembers());
    reloadUser();
  }, [dispatch, reloadStore]);

  useEffect(() => {
    getPlans().then((res) => {
      let activePlanSeen = false;
      let plans = res.map((plan) => {
        if (!active_plan) {
          plan.text = "Choose Plan";
          return plan;
        }
        if (active_plan?.plan_id === plan.id) {
          activePlanSeen = true;
          plan.text = "Current Plan";
          return plan;
        }
        if (!activePlanSeen && active_plan?.plan_id !== plan.id) {
          plan.text = "Downgrade";
          if (active_plan.planName === "Free") {
            plan.text = "Upgrade";
          }
        } else {
          plan.text = "Upgrade";
        }
        return plan;
      });
      setPlans(plans);
    });
    loadCards();
  }, [loadCards, active_plan]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const TabsItemSuperAdmin = [
    {
      label: "Overview",
      icon: <VisibilityIcon />,
    },
    {
      label: "Teams",
      icon: <PeopleIcon />,
    },
    {
      label: "Plans",
      icon: <PaymentIcon />,
    },

    {
      label: "Billing Cards",
      icon: <PaymentIcon />,
    },
  ];

  const TabsItemTeamMember = [
    {
      label: "Overview",
      icon: <VisibilityIcon />,
    },
    {
      label: "Teams",
      icon: <PeopleIcon />,
    },
  ];

  const functionTwoMain = () => {
    setBillings(true);
    setValue(3);
  };

  const functionThreeMain = () => {
    setBillings(false);
  };

  const upgradePlan = (planId) => {
    toast.notify("Upgrading plan");
    // setReloadStore(true);
    // setValue(1);
    // setReloadStore(false);
  };

  const handleBackButtonClick = () => {
    window.history.back();
  };

  return (
    <Accounts.Wrapper className={classes.root}>
      <div>
        <button onClick={handleBackButtonClick} className={classes.backButton}>
          Back
        </button>
      </div>
      <AppBar position="static" color="default" className="Tab__bar">
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="on"
          indicatorColor="primary"
          textColor="primary"
          aria-label="scrollable force tabs example"
          // initialSelectedIndex={value}
        >
          {!isTeamMember
            ? TabsItemSuperAdmin.map((item, index) => {
                return (
                  <Tab
                    key={item.label}
                    label={item.label}
                    icon={item.icon}
                    {...a11yProps(index)}
                  />
                );
              })
            : TabsItemTeamMember.map((item, index) => {
                return (
                  <Tab
                    key={item.label}
                    label={item.label}
                    icon={item.icon}
                    {...a11yProps(index)}
                  />
                );
              })}
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <RenderByPermission allowTeamMemberAccess={true}>
          <UserInfo user={user} />
        </RenderByPermission>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <RenderByPermission allowTeamMemberAccess={true}>
          <Teams />
        </RenderByPermission>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <RenderByPermission allowTeamMemberAccess={false}>
          <PlansAccount
            upgradePlan={upgradePlan}
            user={user}
            plans={plans}
            reloadStore={setReloadStore}
            loadCards={loadCards}
            cardList={cardList}
            functionTwoMain={functionTwoMain}
          />
        </RenderByPermission>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <RenderByPermission allowTeamMemberAccess={false}>
          <BillingCards
            cardList={cardList}
            loadCards={loadCards}
            columns={columns}
            billings={billings}
            functionThreeMain={functionThreeMain}
          />
        </RenderByPermission>
      </TabPanel>
    </Accounts.Wrapper>
  );
};

Accounts.Wrapper = styled.div`
  .Tab__bar {
    background-color: #fff;
    box-shadow: none;
    border-bottom: 1px solid #e1e1e1;
  }
`;
export default Accounts;
